import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { downloadPdf } from "../../Store/requestPdf/actions";

import TextDNI from "./FormElements/ThankYouText/TextDNI";
import TextAdjuntar from "./FormElements/ThankYouText/TextAdjuntar";
import Footer from "../../Components/Footer";
import TextCE from "./FormElements/ThankYouText/TextCE";
import TextCodigoPago from "./FormElements/ThankYouText/TextCodigoPago";

export const thankYouPage = () => {
  const [loadingClick, setLoadingClick] = useState<any>(false);
  const simulacionClient = useSelector((state: any) => state.simulate.policy.client);
  const [idCotizacionNum, setIdCotizacionNum] = useState<any>({});
  const [adjuntarText, setAdjuntarText] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const irSimulaciones = () => {
    history.push("/simulaciones");

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Gracias",
        name: "Click",
        label: "Nueva cotización",
      },
      event: "trackAction",
    });
  };

  const irCotizaciones = () => {
    history.push("/cotizaciones");

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Gracias",
        name: "Click",
        label: "Nueva cotización",
      },
      event: "trackAction",
    });
  };

  const irHome = () => {
    history.push("/productos");
  };

  useEffect(() => {
    setIdCotizacionNum({
      idCotizacion: location.state ? location.state.idCotizacion : simulacionClient.numSimulacion,
    });
    setAdjuntarText(location.state.loadFile);
  }, [location]);

  const uploadRequest = (dataSimulation: any) => {
    setLoadingClick(true);

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Gracias",
        name: "Click",
        label: "Descarga solicitud",
      },
      event: "trackAction",
    });

    setTimeout(() => {
      downloadPdf(dispatch, dataSimulation.idCotizacion, setLoadingClick);
    }, 500);
  };

  useEffect(() => {
    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:gracias",
      },
      event: "trackVirtual",
    });
  }, []);

  const validateDatosCliente = simulacionClient.datosCliente
    ? simulacionClient.datosCliente.tipoDoc.nombre
    : "-";

  return (
    <>
      <div className="wrap">
        <div className="">
          <div className="thankyou-page">
            <div className="thankyou-page__box">
              <div>
                <div className={`thankyou-page__furniture`}></div>
              </div>
            </div>
            <div>
              {adjuntarText ? (
                <TextAdjuntar
                  data={idCotizacionNum}
                  loadingClick={loadingClick}
                  action={irCotizaciones}
                  actionSecundary={irHome}
                />
              ) : (
                Object.keys(simulacionClient).length !== 0 &&
                (location.state.codigoPago !== undefined && location.state.codigoPago ? (
                  <TextCodigoPago
                    data={simulacionClient.datosCliente.datosParticulares.email}
                    loadingClick={loadingClick}
                    action={irCotizaciones}
                    actionSecundary={irSimulaciones}
                  />
                ) : // TODO: la gente loca quiere por tipo de documento
                validateDatosCliente === "DNI" ? (
                  <TextDNI
                    data={simulacionClient.datosCliente.datosParticulares.email}
                    loadingClick={loadingClick}
                    action={irCotizaciones}
                    actionSecundary={irSimulaciones}
                  />
                ) : (
                  <TextCE
                    data={idCotizacionNum}
                    loadingClick={loadingClick}
                    action={irCotizaciones}
                    actionSecundary={irHome}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
